import React, { useState } from 'react';
import {
  Box,
  Container,
  Divider,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from '@mui/material';
import { CreateGameConfig } from '@par/shared/types/game';
import { Profile } from '@par/shared/types/player';
import { CreateTourneyGameDialog } from '../../dialog/CreateTourneyGameDialog';
import { ImageDisplay } from '../../dialog/ImageDisplay';

type ActiveSubTabs = 'rules' | 'format' | 'create-game';

type PropTypes = {
  onTourneyGameCreate: (gameConfig: CreateGameConfig) => void;
  profile: Profile;
};

export const TourneySubNav = ({ onTourneyGameCreate, profile }: PropTypes) => {
  const theme = useTheme();
  const [openTourneyGameDialog, setOpenTourneyGameDialog] = useState(false);
  const [openTourneyImage, setOpenTourneyImage] = useState(false);
  const [tourneyImgSource, setTourneyImgSource] = useState('');

  const SubHeaderTab = (isActiveTab: boolean, text: string) => (
    <Typography
      variant={isActiveTab ? 'subtitle2led' : 'subtitle2'}
      letterSpacing={2}
      sx={{
        color: !isActiveTab ? '#94ff00' : '#94ff00',
        filter: isActiveTab
          ? 'drop-shadow(0 0 15px #94ff00) drop-shadow(0 0 50px #94ff00) contrast(2)'
          : null,
      }}
    >
      {text}
    </Typography>
  );

  const handleFormatClick = () => {
    setTourneyImgSource(
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1695537527/beta-tourney-6-flow_pmkxic.png'
    );
    setOpenTourneyImage(true);
  };

  const handleRulesClick = () => {
    setTourneyImgSource(
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1702358185/Tournament_Rules_kqkrzl.jpg'
    );
    setOpenTourneyImage(true);
  };

  const handleSubNavChange = (event: any, tab: ActiveSubTabs) => {
    if (tab === 'rules') handleRulesClick();
    if (tab === 'format') handleFormatClick();
    if (tab === 'create-game') setOpenTourneyGameDialog(true);
  };

  const modals = (
    <>
      <CreateTourneyGameDialog
        close={() => setOpenTourneyGameDialog(false)}
        onTourneyGameCreate={onTourneyGameCreate}
        open={openTourneyGameDialog}
      />
      <ImageDisplay
        closeImageDisplay={() => setOpenTourneyImage(false)}
        imgSource={tourneyImgSource}
        openImageDisplay={openTourneyImage}
      />
    </>
  );

  return (
    <>
      {modals}
      <Container>
        <Box display={'flex'} justifyContent={'left'} mt={2}>
          <Tabs
            variant="scrollable"
            value={false}
            onChange={handleSubNavChange}
            indicatorColor="secondary"
            sx={{
              width: '100%',
              height: 0,
              borderRadius: '10px',
              bgcolor: '#313731',
              '& .MuiTabs-flexContainer': { height: '100%' },
            }}
          >
            <Tab label={SubHeaderTab(false, 'Rules')} value="rules" />
            <Divider
              flexItem
              orientation="vertical"
              sx={{
                height: '40%',
                alignSelf: 'center',
                borderRightWidth: 2,
              }}
            />
            <Tab label={SubHeaderTab(false, 'Format')} value="format" />
            {profile.admin ? (
              <Divider
                flexItem
                orientation="vertical"
                sx={{
                  height: '40%',
                  alignSelf: 'center',
                  borderRightWidth: 2,
                }}
              />
            ) : null}
            {profile.admin ? (
              <Tab
                label={SubHeaderTab(false, 'Create Game')}
                value="create-game"
              />
            ) : null}
          </Tabs>
        </Box>
      </Container>
    </>
  );
};
